<div #elementRef></div>

<button
  mat-raised-button
  [matTooltip]="tooltip"
  [matTooltipPosition]="tooltipPosition"
  class="button-scroll"
  [ngClass]="{top: location == 'top', bottom: location == 'bottom'}"
  (click)="goTo()">
  <mat-icon *ngIf="location == 'top'">keyboard_arrow_down</mat-icon>
  <mat-icon *ngIf="location == 'bottom'">expand_less</mat-icon>
</button>
